(() => {
  const init = (root = document) => {
    root.querySelectorAll('.ff-folio-carousel-window').forEach(track => {
      if (track.dataset.folioReady) return;
      track.dataset.folioReady = 'true';
      const controls = track.nextElementSibling;
      const cards = Array.from(track.querySelectorAll('.ff-folio-product'));
      const previous = controls.querySelector('.ff-folio-carousel-prev');
      const next = controls.querySelector('.ff-folio-carousel-next');
      const count = controls.querySelector('.ff-folio-carousel-count');
      if (!cards.length || !previous || !next || !count) return;
      let initialMobilePositioned = false;
      const mobile = window.matchMedia('(max-width: 749px)');
      const position = card => card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      const current = () => {
        if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) return cards.length - 1;
        return cards.reduce((best, card, i) => Math.abs(position(card) - track.scrollLeft) < Math.abs(position(cards[best]) - track.scrollLeft) ? i : best, 0);
      };
      const update = () => {
        const index = track.scrollWidth <= track.clientWidth + 2 ? 0 : current();
        count.textContent = `${index + 1} / ${cards.length}`;
        previous.disabled = index === 0;
        next.disabled = index === cards.length - 1;
      };
      const positionInitialMobile = () => {
        if (initialMobilePositioned || !mobile.matches || track.clientWidth <= 0) return;
        const statement = cards.find(card => card.id === 'statement');
        initialMobilePositioned = true;
        if (statement) track.scrollTo({left: position(statement), behavior: 'auto'});
        update();
      };
      const move = direction => {
        const target = Math.max(0, Math.min(cards.length - 1, current() + direction));
        track.scrollTo({left: position(cards[target]), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      window.addEventListener('resize', () => {positionInitialMobile(); update();}, {passive: true});
      document.fonts?.ready.then(() => {positionInitialMobile(); update();});
      positionInitialMobile();
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
